var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload01 = function SvgDownload01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13 9v.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C11.48 13 10.92 13 9.8 13H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 11.48 1 10.92 1 9.8V9m9.333-3.333L7 9m0 0L3.667 5.667M7 9V1"
  })));
};
export default SvgDownload01;